import { render, staticRenderFns } from "./AccountButtons.vue?vue&type=template&id=8bcbfd70"
import script from "./AccountButtons.vue?vue&type=script&lang=ts"
export * from "./AccountButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports